export default __webpack_public_path__ + "static/media/3WL.27dfaf32.jpg";